const NO_RESULTS_ERROR = 'ZERO_RESULTS'
const GOOGLE = 'google'
const OPENTRIPPLANNER = 'opentripplanner'
const TRANSIT = 'TRANSIT'

function isEmpty(value) {
  return !value || value.length === 0
}

function getTransitSteps(route) {
  return (route.leg.steps || []).filter(step => step.travel_mode === TRANSIT)
}

function isRouteAllowedByAgencies(route, agenciesWhitelistUrls = []) {
  const transitSteps = getTransitSteps(route)
  const allowedTransitSteps = transitSteps.filter(step =>
    agenciesWhitelistUrls.includes(step.transit.line.agencies[0].url)
  )

  return !isEmpty(allowedTransitSteps) && transitSteps.length === allowedTransitSteps.length
}

export function buildLegacyPlannerFilteredRoutes({ routes, motor, agenciesWhitelistUrls = [] }) {
  if (motor === GOOGLE || motor === undefined) {
    if (!routes) { return { routes: [] } }

    if (!isEmpty(agenciesWhitelistUrls)) {
      return {
        routes: routes.filter(route => isRouteAllowedByAgencies(route, agenciesWhitelistUrls))
      }
    }

    return { routes }
  }

  if (motor === OPENTRIPPLANNER) {
    return { routes }
  }

  return {
    routes: null,
    error: NO_RESULTS_ERROR
  }
}

export async function fetchLegacyPlannerRoutes({
  motor,
  googleDirectionsApi,
  otpDirectionsApi,
  temporalReferenceParams,
  origin,
  destination,
  administrativeAreaTimeZone,
  otpUrl,
  originDirection,
  destinationDirection
}) {
  if (motor === GOOGLE || motor === undefined) {
    const response = await googleDirectionsApi.index({
      transitOptions: temporalReferenceParams,
      origin,
      destination
    })

    return response.routes
  }

  if (motor === OPENTRIPPLANNER) {
    const response = await otpDirectionsApi.index({
      transitOptions: temporalReferenceParams,
      origin,
      destination,
      administrativeAreaTimeZone,
      otp_url: otpUrl,
      originDirection,
      destinationDirection
    })

    return response.routes
  }

  return []
}
